import { Component } from '@angular/core';
import { Language } from '@galaxy/atlas/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { setLanguage } from '@vendasta/galaxy/i18n';

export interface LanguageMapping {
  code: Language;
  label: string;
  flag?: SafeResourceUrl;
}

@Component({
  selector: 'bc-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  standalone: false,
})
export class LanguageSelectorComponent {
  private urlLanguageCode: string;

  languageOptions: LanguageMapping[] = [
    {
      label: 'Čeština',
      code: Language.CZECH,
      flag: this.sanitizer.bypassSecurityTrustResourceUrl(
        // todo: serve from BCC or a central CDN
        'https://vstatic-prod.apigateway.co/digital-ads-client/assets/images/flags/czech_republic.svg',
      ),
    },
    {
      label: 'Deutsch',
      code: Language.GERMAN,
      flag: this.sanitizer.bypassSecurityTrustResourceUrl(
        // todo: serve from BCC or a central CDN
        'https://vstatic-prod.apigateway.co/digital-ads-client/assets/images/flags/germany.svg',
      ),
    },
    {
      label: 'English',
      code: Language.ENGLISH,
      flag: this.sanitizer.bypassSecurityTrustResourceUrl(
        // todo: serve from BCC or a central CDN
        'https://vstatic-prod.apigateway.co/digital-ads-client/assets/images/flags/united_states.svg',
      ),
    },
    {
      label: 'Español',
      code: Language.SPANISH_LATIN_AMERICA,
      flag: this.sanitizer.bypassSecurityTrustResourceUrl(
        'https://vstatic-prod.apigateway.co/digital-ads-client/assets/images/flags/spain.svg',
      ),
    },
    {
      label: 'Français',
      code: Language.FRENCH,
      flag: this.sanitizer.bypassSecurityTrustResourceUrl(
        // todo: serve from BCC or a central CDN
        'https://vstatic-prod.apigateway.co/digital-ads-client/assets/images/flags/france.svg',
      ),
    },
    {
      label: 'Nederlands',
      code: Language.DUTCH,
      flag: this.sanitizer.bypassSecurityTrustResourceUrl(
        // todo: serve from BCC or a central CDN
        'https://vstatic-prod.apigateway.co/digital-ads-client/assets/images/flags/belgium.svg',
      ),
    },
  ];

  constructor(private sanitizer: DomSanitizer) {}

  public changeLanguage(language: Language): void {
    if (!language || language === this.urlLanguageCode) {
      return;
    }
    this.setLanguage(language);
    window.location.reload();
  }

  public setLanguage(language: Language): void {
    if (!language) {
      return;
    }
    setLanguage(language);
  }
}
